"use strict"
module.exports = {...require('./helpers'), ...require('./methods')};